import { MIN_WIDTH_MD } from '@catapultsports/referee-design-tokens';
import { css } from 'linaria';

export const listBoxStyle = css`
    position: absolute;
    z-index: 110;
    display: none;
    list-style: none;
    border-radius: 4px;
    padding: 0;
    margin: 0;

    // this is to fix z-index on mobile safari
    -webkit-transform: translateZ(100px);

    &:focus-visible {
        outline: none;
    }
`;

export const listOptionStyle = css`
    display: flex;
    align-items: center;
    justify-content: space-between;
    background: #fff;
    color: #000;
    padding: 15px 16px;

    min-width: 320px;
    max-width: 524px;

    @media screen and (min-width: ${MIN_WIDTH_MD}px) {
        min-width: 524px;
    }

    &:hover {
        background-color: #ebebeb;
    }

    &:first-child {
        padding-top: 23px;
        border-radius: 4px 4px 0 0;
    }

    &:last-child {
        padding-bottom: 23px;
        border-radius: 0 0 4px 4px;
    }
`;

export const addScrollStyle = css`
    overflow-y: scroll;

    -ms-overflow-style: none;
    scrollbar-width: none;

    &::-webkit-scrollbar {
        display: none;
    }
`;

export const activeStyle = css`
    display: flex;
`;

export const openStyle = css`
    display: block;
`;
